// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

function handlePDPNavigation(){
  // console.log('handlePDPNavigation');

  const activeClass = 'active';
  const hiddenClass = 'hidden';
  let currentIndex = 0;

  function updateActiveImage(index) {

    const desktopGallery = document.querySelector('.product__media-container.above-mobile');
    const largeImages = desktopGallery.querySelectorAll('.product__media-item');
    const thumbnails = desktopGallery.querySelectorAll('.product-thumbnails__item-link');

    currentIndex = index;
    if (index < 0) currentIndex = largeImages.length - 1;
    if (index == largeImages.length) currentIndex = 0;

    // Clamp index between 0 and last index
    // index = Math.max(0, Math.min(index, largeImages.length - 1));
    // currentIndex = index;

    // Remove all active classes
    largeImages.forEach(img => img.classList.add(hiddenClass));
    thumbnails.forEach(thumb => thumb.classList.remove(activeClass));

    // console.log('currentIndex:', currentIndex);

    // Add active to the current
    largeImages[currentIndex].classList.remove(hiddenClass);
    thumbnails[currentIndex].classList.add(activeClass);
  }

  // Prev and Next buttons
  document.addEventListener('click', (e) => {
    if (e.target.closest('button').classList.contains('carousel__navigation-button--back')) {
      // console.log('prevBtn currentIndex:', currentIndex);
      updateActiveImage(currentIndex - 1);
    }
    if (e.target.closest('button').classList.contains('carousel__navigation-button--forward')) {
      // console.log('nextBtn currentIndex:', currentIndex);
      updateActiveImage(currentIndex + 1);
    }
  });

  document.addEventListener("product:variant-change", function (evt) {
    currentIndex = 0
  });

  // Optional: Initialize on load
  updateActiveImage(0);

}//handlePDPNavigation

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);

  
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
// This event is exposed when a 'Variant selectors' block has been added to
// a product template or featured product section
// The selected variant object is passed within the detail object.
let variant_metafields = document.querySelector('[data-variant-metafields]');
if(variant_metafields){
  variant_metafields = JSON.parse(document.querySelector('[data-variant-metafields]')?.innerText)
}
//console.log('variant_metafields 2', variant_metafields);
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  //console.log(evt.detail.variant);
  //console.log(evt.detail.variant.id);
    let selected_variant_meta = variant_metafields.filter( function(variant){
      //  console.log('variant: ', variant);
       if (variant.variant_id == evt.detail.variant.id){
         document.querySelector('.product__description.product__block.product__block--medium div').innerHTML = variant.model_info
       }
    } );
  //console.log('selected_variant_meta', selected_variant_meta);
});

// This event fires whenever a product quanatiy is updated.
// This event is exposed when a 'Quantity selector' block has been added to
// a product template or featured product section
// The quantity and selected variant object is passed within the detail object.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
// This event is exposed when the 'Enable quick view' feature is enabled
// And a quick view modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});

////
document.addEventListener('click', function(event) {
  const clickedElement = event.target;

  // Check if the clicked element has the class 'product-swatches-options__item'
  if (clickedElement.classList.contains('product-swatches-options__item') && !clickedElement.classList.contains('selected')) {
    
    let variant_id = clickedElement.getAttribute('data-variant-id');
    let variant_img = clickedElement.getAttribute('data-variant-image');
    let variant_img_hover = clickedElement.getAttribute('data-variant-hover-image');
    let variant_option_name = clickedElement.getAttribute('aria-label').replace('color ','');
    let variant_price = clickedElement.getAttribute('data-variant-price');
    let variant_compare = clickedElement.getAttribute('data-variant-compare');
    
    let elementParent = clickedElement.closest('.product-item__inner');

    if( variant_id ){
      //Update product card link
      let currentLink = new URL( window.location.origin + elementParent.querySelector('.product-item__image-link').getAttribute('href') );
      currentLink.searchParams.set('variant', variant_id);
      let updatedLink = currentLink.toString().replace(location.origin, '')
      elementParent.querySelector('.product-item__image-link').setAttribute( 'href', updatedLink );
      elementParent.querySelector('.product-item__product-title a').setAttribute( 'href', updatedLink );

      //Update Variant prices
      if(variant_price != ''){
        if(elementParent.querySelector('.product-item__price .product-item__price')){
          elementParent.querySelector('.product-item__price .product-item__price').innerText = variant_price;
        }
      }

      if(variant_compare != ''){
        if(elementParent.querySelector('.product-item__price .sale')){
          elementParent.querySelector('.product-item__price .sale').innerText = variant_price;
        }
      }
      
      if(variant_compare != ''){
        if(elementParent.querySelector('.product-item__price .t-subdued')){
          elementParent.querySelector('.product-item__price .t-subdued').innerText = variant_compare;
        }
      }
  
      //Update product card image
      elementParent.querySelector('.product-item__image--one img').setAttribute('srcset', '')
      elementParent.querySelector('.product-item__image--one img').setAttribute('src', variant_img);
      elementParent.querySelector('.product-item__image--two img').setAttribute('srcset', '')
      elementParent.querySelector('.product-item__image--two img').setAttribute('src', variant_img_hover);
  
      //Update selected Option Name
      elementParent.querySelector('.product-swatches-options-selected-name').innerText = variant_option_name;
      
      const siblingElements = clickedElement.parentNode.children;
      for (let sibling of siblingElements) {
        if (sibling !== clickedElement && sibling.classList.contains('selected')) {
          sibling.classList.remove('selected');
        }
      }
      clickedElement.classList.add('selected');
    }
  }
});

function minimum_spend_promo_bar (){
  const bar_container = document.querySelector('.minimum-spend-promo-bar');
  if( bar_container ){
    const bar_threshold = bar_container.getAttribute('data-minimum-spend-promo-bar-threshold');
    const bar_success_message = bar_container.getAttribute('data-minimum-spend-promo-bar-success-message');
    const bar_pending_mesage = bar_container.getAttribute('data-minimum-spend-promo-bar-pending-message');

    document.addEventListener("cart:updated", function (evt) {
      console.log("minimum_spend_promo_bar:", evt.detail.cart);
      const cart_total = evt.detail.cart.items_subtotal_price;

      const remainining_amount = bar_threshold - cart_total;
      let remainining_percentage = (cart_total / bar_threshold) * 100;
      let remainining_amount_adjusted = remainining_amount / 100.0;

      if(remainining_amount < 0){
        remainining_percentage = 100;
      }

      if(remainining_amount > 0){
        bar_container.querySelector('.minimum-bar__bar-progress-text').innerHTML = bar_pending_mesage.replace('[[remaining]]', `$${remainining_amount_adjusted}`);

        bar_container.querySelector('.minimum-bar__bar').setAttribute('style', `--progress-width: ${remainining_percentage}%;`)
      }else{
        bar_container.querySelector('.minimum-bar__bar-progress-text').innerHTML = bar_success_message;
        bar_container.querySelector('.minimum-bar__bar').setAttribute('style', `--progress-width: 100%;`)
      }

    })
  }
}

minimum_spend_promo_bar();

// Control arrows for Desktop PDP Gallery
document.addEventListener('DOMContentLoaded', () => {
  handlePDPNavigation();
});